<template>
  <div class="card z-index-2">
    <div class="pb-0 card-header mb-0">
      <h6>{{ props.title }}</h6>
      <p v-if="props.description" class="text-sm" v-html="props.description" />
    </div>
    <div class="p-3 card-body">
      <div class="chart">
        <canvas :id="props.id" class="chart-canvas" :height="props.height"></canvas>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue';
import { Chart } from 'chart.js/auto';

import axios from 'axios';
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  height: {
    type: String,
    default: "300",
  },
  title: {
    type: String,
    default: "",
  },
  description: {
    type: String,
    default: "",
  },
});

let chartInstance = null;

// Datos predeterminados
const defaultRecordedHours = [0, 0, 0, 0, 0, 0, 0]; // Valores iniciales de "Horas Capturadas"

const chartData = ref({
  labels: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
  datasets: [
    {
      label: "Horas a Capturar",
      backgroundColor: "#3d3d3d", // Gris
      borderColor: "#3d3d3d",
      borderWidth: 1,
      data: [9.6, 9.6, 9.6, 9.6, 9.6, 0, 0], // Datos iniciales de "horas a capturar"
    },
    {
      label: "Horas Capturadas",
      backgroundColor: "#01a5f5", // Naranja
      borderColor: "#01a5f5",
      borderWidth: 1,
      data: defaultRecordedHours, // Inicialmente vacío
    },
  ],
});

// Función para renderizar el gráfico
const renderChart = () => {
  const ctx = document.getElementById(props.id)?.getContext('2d'); // Asegúrate de que 'getContext' no sea llamado en null
  if (ctx) {
    if (chartInstance) {
      chartInstance.destroy(); // Destruir instancia previa
    }
    chartInstance = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: chartData.value.labels,
        datasets: chartData.value.datasets,
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
          },
          tooltip: {
            enabled: true,
          },
        },
      },
    });
  } else {
    console.error('Canvas no encontrado, no se puede renderizar el gráfico');
  }
};

// Simulación de la llamada a la API
const fetchHoras = async () => {
  const fetchedHours = Array(7).fill(0);
  try {
    const response = await axios.post(`${API_BASE_URL}/user-week-hours`, {}, {
      headers: {
        Authorization: `Bearer ${token}`, // Agrega el token en el header
      },
    });
    //Recorrer los datos y asignar las horas al día correspondiente
    response.data.data.forEach(entry => {
      const date = new Date(entry.date);
      const dayIndex = date.getDay(); // Obtiene el índice del día (0 = Domingo, ..., 6 = Sábado)
      fetchedHours[dayIndex] += entry.total_hours; // Suma las horas al día correspondiente
    });
    chartData.value.datasets[1].data = fetchedHours; // Actualizamos las horas capturadas
    renderChart(); // Renderizamos el gráfico nuevamente con los nuevos datos
  } catch (error) {
    console.error('Error al obtener los datos de clientes:', error);
  }
};

// Aseguramos que el DOM esté completamente cargado antes de renderizar el gráfico
onMounted(async () => {
  await nextTick(); // Esperamos a que el DOM y Vue estén completamente listos
  renderChart();  // Renderizamos el gráfico con los datos iniciales
  fetchHoras();   // Llamamos a la API para actualizar los datos
});
</script>

<style scoped>
.card {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
}

.chart-canvas {
  max-height: 100%;
  max-width: 100%;
}
</style>